module.exports = __webpack_public_path__ + "static/media/15.426499e5.jpg";